var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnreadEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 178620",
    xmlns: "http://www.w3.org/2000/svg",
    width: 298,
    height: 160,
    viewBox: "0 0 298 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wbubvbdu7a",
    x1: 0.5,
    y1: 0.014,
    x2: 0.5,
    y2: 0.559,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 464",
    cx: 149,
    cy: 44.5,
    rx: 149,
    ry: 44.5,
    transform: "translate(0 71)",
    style: {
      fill: "url(#wbubvbdu7a)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178595"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178594"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178622"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178576"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178573"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29445",
    d: "M431.174 699.157v74.555l-55.164-6.124a6.123 6.123 0 1 1-12.245 0v-59.366l9.064-9.065z",
    transform: "translate(-248.439 -674.796)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29446",
    d: "M425.675 768.713h-.055l-54.631-6.065a6.623 6.623 0 0 1-13.223-.557v-59.368a.5.5 0 0 1 .147-.354l9.064-9.065a.5.5 0 0 1 .354-.146h58.345a.5.5 0 0 1 .5.5v74.555a.5.5 0 0 1-.5.5zm-66.909-65.783v59.159a5.622 5.622 0 1 0 11.244 0 .5.5 0 0 1 .556-.5l54.608 6.062v-73.5h-57.637z",
    transform: "translate(-242.94 -669.297)",
    style: {
      fill: "#e6e6ea"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178574"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29447",
    d: "M498.441 1525.578h-61.287a6.123 6.123 0 0 0 6.123-6.123z",
    transform: "translate(-315.706 -1426.663)",
    style: {
      fill: "#e6e6ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29448",
    d: "M492.941 1520.577h-61.286a.5.5 0 1 1 0-1 5.629 5.629 0 0 0 5.623-5.623.5.5 0 0 1 .556-.5L493 1519.58a.5.5 0 0 1-.055 1zm-57.788-1h48.742l-45.64-5.066a6.63 6.63 0 0 1-3.102 5.065z",
    transform: "translate(-310.207 -1421.162)",
    style: {
      fill: "#e6e6ea"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178575"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29449",
    d: "M372.829 699.157v9.065h-9.064z",
    transform: "translate(-248.439 -674.796)",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29450",
    d: "M367.329 703.223h-9.064a.5.5 0 0 1-.354-.854l9.064-9.065a.5.5 0 0 1 .854.354v9.065a.5.5 0 0 1-.5.5zm-7.856-1h7.355v-7.356z",
    transform: "translate(-242.939 -669.297)",
    style: {
      fill: "#e6e6ea"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178585"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178577"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 146433",
    style: {
      fill: "#e6e6ea"
    },
    d: "M0 0h12.247v1.001H0z",
    transform: "translate(122.21 39.819)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178578"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 146434",
    style: {
      fill: "#e6e6ea"
    },
    d: "M0 0h52.972v1.001H0z",
    transform: "translate(122.21 46.523)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178579"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 146435",
    style: {
      fill: "#e6e6ea"
    },
    d: "M0 0h52.972v1.001H0z",
    transform: "translate(122.21 53.227)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178580"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 146436",
    style: {
      fill: "#e6e6ea"
    },
    d: "M0 0h52.972v1.001H0z",
    transform: "translate(122.21 59.932)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178581"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 146437",
    style: {
      fill: "#e6e6ea"
    },
    d: "M0 0h52.972v1.001H0z",
    transform: "translate(122.21 66.636)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178582"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 146438",
    style: {
      fill: "#e6e6ea"
    },
    d: "M0 0h52.972v1.001H0z",
    transform: "translate(122.21 73.34)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178583"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 146439",
    style: {
      fill: "#e6e6ea"
    },
    d: "M0 0h52.972v1.001H0z",
    transform: "translate(122.21 80.044)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178584"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 146440",
    style: {
      fill: "#e6e6ea"
    },
    d: "M0 0h30.382v1.001H0z",
    transform: "translate(122.21 86.749)"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178593"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178586",
    transform: "translate(155.089 15.907)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1789",
    cx: 19.582,
    cy: 19.582,
    r: 19.582,
    transform: "translate(.302 .302)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29451",
    d: "M667.762 642.66a19.821 19.821 0 1 1 7.482-1.456 19.816 19.816 0 0 1-7.482 1.456zm0-39.154a19.271 19.271 0 1 0 13.633 5.638 19.219 19.219 0 0 0-13.633-5.638z",
    transform: "translate(-647.879 -602.894)",
    style: {
      fill: "#e6e6ea"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29452",
    d: "M774.4 705.014a15 15 0 0 0-21.179 21.179 15 15 0 1 1 21.179-21.179z",
    transform: "translate(-588.019 -679.285)",
    style: {
      fill: "#f5f5f7",
      opacity: 0.997
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178587"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29453",
    d: "M757.36 725.452a15.344 15.344 0 1 1 15.109-18.052l.053.3-.594.105-.053-.3a14.742 14.742 0 1 0 0 5.169l.052-.3.594.1-.052.3a15.35 15.35 0 0 1-15.113 12.669z",
    transform: "translate(-582.164 -674.332)",
    style: {
      fill: "#e6e6ea"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178609",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178605"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178602"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29460",
    d: "M1036.327 313.1a.766.766 0 0 1-.558-.24l-12.031-12.679a.769.769 0 1 1 1.116-1.059l12.031 12.679a.769.769 0 0 1-.558 1.3z",
    transform: "translate(-855.339 -270.204)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178603"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29461",
    d: "M1055.31 331.741a.423.423 0 0 1-.308-.132l-12.031-12.679a.424.424 0 0 1 .615-.584l12.031 12.679a.424.424 0 0 1-.308.716z",
    transform: "translate(-874.322 -289.187)",
    style: {
      fill: "#949494"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178608"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178602"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29460",
    d: "M1024.3 313.1a.768.768 0 0 0 .558-.24l12.031-12.679a.769.769 0 1 0-1.115-1.059l-12.036 12.678a.769.769 0 0 0 .557 1.3z",
    transform: "translate(-855.339 -270.204)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178603"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29461",
    d: "M1043.279 331.741a.423.423 0 0 0 .308-.132l12.031-12.679a.424.424 0 0 0-.616-.584l-12.031 12.679a.424.424 0 0 0 .308.716z",
    transform: "translate(-874.322 -289.187)",
    style: {
      fill: "#949494"
    }
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadEmpty);
export default __webpack_public_path__ + "static/media/UnreadEmpty.2fa8459eb1fa7f9e3c14d9fd4822ec64.svg";
export { ForwardRef as ReactComponent };